module.exports = __webpack_public_path__ + "static/media/dropdownEnterpriseIcon.b8df7e37.svg";